<template>
    <div class="container" v-if="!fetching">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index < 4" class="img" :src="item">
            <div class="activityImg" v-if="activity.isShow && index == 0">
                <img :src="activity.H5activeImg">
            </div>
        </div>
        <div class="section-main">
            <img class="s-title" :src="tabMain.h5titleImg">
            <div class="s-main">
                <van-tabs :swipe-threshold="4" v-model="active">
                    <van-tab v-for="(item, index) in (tabMain.stageList || [])" :key="index" :title="item.stage" class="tb">
                        <div class="t-title">
                            {{item.title}}
                        </div>
                        <img class="t-icon" src="https://s21.lgstatic.com/growth/activity/20210419/1618820076232.png">
                        <div class="target">
                            <div class="title">
                                <div class="target-link"></div>
                                <div class="text">学习目标</div>
                                <div class="btn" @click="showModal(item)"></div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.phaseTargetList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                            <div class="title title1">
                                <div class="target-link"></div>
                                <div class="text">关键技术点</div>
                            </div>
                            <div class="content">
                                <div v-for="(val,ind) in item.skillsList" :key="ind" class="content-list">
                                    <div class="icon"></div>
                                    <div class="text">{{val}}</div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
                <button class="btn-receive" @click="JumpFn">
                    <img :src="btnImg.receive">
                </button>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index == 4 || index == 5" class="img" :src="item">
        </div>
        <div class="tab-img">
            <van-tabs v-model="active_img">
                <van-tab v-for="(item, index) in tabImgList" :key="index" :title="item.title" class="tb">
                    <img class="img" :src="item.desc">
                </van-tab>
            </van-tabs>
            <button class="btn-getmore" @click="JumpFn">
                <img :src="btnImg.getmore">
            </button>
        </div>
        <div class="tab-fill"></div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index > 5" class="img" :src="item">
        </div>

        <div :class="{'modal-container': true, active: modalVisable}" v-if="modalVisable">
            <div :class="{'layer': true, active: modalVisable}"/>
            <div class="modal">
                <div class="modal-content active">
                    <div class="close-container">
                        <div
                            class="close"
                            @click="closeModal"
                        />
                    </div>
                    <div>
                        <div class="title">
                            {{ moadlData.title }}
                            <div class="sub-title">
                                {{ moadlData.stage }}
                            </div>
                        </div>
                        <div class="content">
                            <div v-for="(val,inde) in moadlData.details" :key="inde">
                                <div class="content-title">
                                    {{val.t}}
                                </div>
                                <div class="content-desi" v-for="(i,its) in val.desc" :key="its">
                                    {{i}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template>
            <ClueFooter 
                :bgStyle="{background: 'linear-gradient(90deg, #FF5325 0%, #EB0505 100%)'}"
                v-if="firstBtnType"
                :id="98"
                :isDcsj="false"
                showPoup
                @jump="JumpFn('亮片名额有限立即抢占')"
            />
            <button class="footer" @click="JumpFn" v-else>
                <img v-if="isBView === 'A'" :src="btnImg.footer">
                <img v-if="isBView === 'B'" :src="btnImg.footerB">
                <img class="H5activityIcon" v-if="activity.isShow" :src="activity.H5icon">
                <FooterPoup
                    :id="98"
                    :isDcsj="false"
                />
            </button>
        </template>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import { Tab, Tabs } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);

import activity from '../../../common/activity';
import List from './list'
export default {
    components: {
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
    },
    props: ['isBView'],
    data() {
        return {
            activity,
            List,
            moadlData:{},//弹窗
            imgList:[],
            tabMain:{},
            btnImg:{},
            active: 0,
            active_img:0,
            modalVisable:false,
            tabImgList:[],
        }
    },
    created () {
        this.saLogin();
    },
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1s5m'});
        },500)
        let dataList = this.List.data.h5;
        this.tabMain = this.List.data.tabMain

        this.imgList = dataList.imgList
        this.btnImg = dataList.btnImg
        this.tabImgList = dataList.tabImgList
    },
    methods: {
        JumpFn(name) {
            let button_name = (this.isBView === 'B' ? '免费领取vip月卡' : '抢先领取试学名额')
            if(name && typeof name ==='string'){
                button_name = name
            }
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s5m',
                'button_name': button_name
            });
            // let key = this.isBView === 'B' ? '9abc23d41003464b8c76dcabbe6f7fdf' : '8e9e05fc691b4938ae6be0ed50422d1b';
            let key = '8e9e05fc691b4938ae6be0ed50422d1b';
            handleJumpUrl(key);
        },
        closeModal(){
            this.looseBody();
            this.modalVisable = false;
        },
        fixedBody() {
            this.selfTop = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.cssText += 'position:fixed;overflow: hidden;height: auto;top: -' + this.selfTop + 'px';
        },
        looseBody() {
            var body = document.body;
            body.style.overflow = 'auto';
            body.style.height = 'auto';
            body.style.position = '';
            document.body.scrollTop = document.documentElement.scrollTop = parseInt(this.selfTop);
        },
        showModal(item){
            console.log(item);
            this.fixedBody();
            this.modalVisable = true;
            this.moadlData = item
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #F1F3FF;
    padding-bottom: 200px;
    .section {
        position: relative;
        width: 100%;
        .img {
            width: 100%;
            display: block;
        }
        .activityImg {
            position: absolute;
            z-index: 11;
            top: 0;
            right: 0;
            width: 157px;
            height: 158px;
            img {
                width: 100%;
            }
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        padding-top: 30px;
        margin-bottom: 100px;
        .s-title {
            position: absolute;
            top: 30px;
            left: 0;
            width: 719px;
            height: 131px;
        }
        .s-main {
            // position: relative;
            margin: 100px auto 0;
            width: 688px;
            background-color: #fff;
            z-index: 2;
            border-radius: 8px;
            padding-bottom: 150px;
            .tb {
                position: relative;
                width: 100%;
                background-color: #fff;
                .t-title {
                    text-align: center;
                    font-size: 32px;
                    color: #555;
                    font-weight: 500;
                    padding: 25px 0 10px;
                }
                .t-icon {
                    width: 688px;
                    display: block;
                    height: 2px;
                }
                .target {
                    color: #3D3D3F;
                    font-size: 26px;
                    margin-top: 35px;
                    .title {
                        display: flex;
                        height: 49px;
                        align-items: center;
                        font-weight: bold;
                    }
                    .title1 {
                        margin-top: 38px;
                    }
                    .target-link {
                        width: 6px;
                        height: 22px;
                        background: linear-gradient(313deg, #7A7AA9 0%, #232545 100%);
                        margin-left: 46px;
                        margin-right: 8px;
                    }
                    .text {
                        flex: 1;
                    }
                    .btn {
                        width: 151px;
                        height: 49px;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40px;
                    }
                    .content {
                        margin-top: 10px;
                    }
                    .content-list {
                        display: flex;
                        color: #595959;
                        line-height: 48px;
                        font-size: 24px;
                        .icon {
                            width: 8px;
                            height: 8px;
                            background: #565659;
                            border-radius: 50%;
                            margin-left: 46px;
                            margin-top: 20px;
                            margin-right: 8px;
                        }
                        .text {
                            opacity: .7;
                            flex: 1;
                            width: 612px;
                            padding-right: 14px;
                        }
                    }
                }
            }
        }
        /deep/ .van-tabs__wrap--scrollable{
            height: 106px;
        }
        /deep/ .van-tabs__nav {
            background: linear-gradient(360deg, #E33917 0%, #FF7500 100%);
            height: 106px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-left-radius: 8px;
            border-top-right-radius: 8px;
        }
        /deep/ .van-tab {
            width: 180px;
            height: 106px;
            color: #fff;
            font-size: 28px;
            font-weight: 400;
        }
        /deep/ .van-tabs__line {
            bottom: 40px;
            background: #fff;
            width: 64px;
            height: 6px;
        }
        .btn-receive {
            position: absolute;
            bottom: -50px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            height: 98px;
            img {
                width: 100%;
                display: block;
            }
        }
        .tips-tab {
            position: absolute;
            bottom: 80px;
            right: 50px;
            color: #666;
            font-size: 14px;
        }
    }
    .tab-img {
        position: relative;
        margin: 30px auto 30px;
        width: 690px;
        background-color: #fff;
        border-radius: 0px 20px 20px 20px;
        padding-bottom: 30px;
        /deep/ .van-tabs__wrap--scrollable{
            height: 86px;
        }
        /deep/ .van-tabs__nav {
            background: rgba(26, 29, 60, 1);
            height: 86px;
        }
        /deep/ .van-tabs--line .van-tabs__wrap {
            border-top-right-radius: 20px;
        }
        /deep/ .van-tab {
            width: 189px;
            height: 86px;
            color: #fff;
            font-size: 30px;
            font-weight: 500;
            background: url('https://s21.lgstatic.com/growth/activity/20210419/1618826009731.png') no-repeat center;
            background-size: 100% 100%;
        }
        /deep/ .van-tab--active {
            background: #fff;
            color: #34397D;
            border-top-right-radius: 20px;
        }
        /deep/ .van-tabs__line {
            background:transparent;
        }
        /deep/ .van-tabs__nav--line {
            padding-bottom: 0;
        }
        .tb {
            width: 100%;
            .img {
                width: 100%;
                display: block;
            }
        }
        .btn-getmore {
            position: absolute;
            bottom: -50px;
            left: 50%;
            transform: translate(-50%);
            background-color:transparent;
            border: none;
            z-index: 9;
            width: 488px;
            height: 98px;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .tab-fill {
        width: 100%;
        height: 250px;
        background-color: rgba(33, 52, 110, 1);
        margin-top: -150px;
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1px;
        z-index: 999;
        width: 100%;
        img {
            width: 100%;
            display: block;
        }
        .H5activityIcon {
            position: absolute;
            top: -50px;
            right: 42px;
            width: 209px;
        }
    }
}
.layer {
        position: fixed;
        z-index: 9;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.6);
        display: none;
        &.active {
            display: block;
        }
    }
.modal {
    position: fixed;
    bottom: 139px;
    z-index: 10;
    display: flex;
    justify-content: center;
    .modal-content {
        width: 750px;
        height: 0;
        opacity: 0;
        transition: height .3s linear;
        overflow-y: scroll;
        &.active {
            opacity: 1;
            height: 962px;
            overflow: hidden;
        }
        background: #fff;
        border-radius: 18px 18px 0 0;
        position: relative;
        margin-right: 45px;
        box-sizing: border-box;
    }
    .close {
        width: 42px;
        height: 42px;
        background: url("https://s21.lgstatic.com/growth/activity/20210402/1617356751440.png") no-repeat;
        background-size: 42px 42px;
        position: absolute;
        right: 30px;
        top: 30px;
        border-radius: 50%;
        z-index: 1;
    }
    .title {
        margin-top: 82px;
        width: 658px;
        font-size: 32px;
        line-height: 40px;
        margin-bottom: 41px;
        padding-left: 45px;
        font-weight: bold;
        &-dot {
            width: 5px;
            height: 5px;
            border-radius: 5px;
            background: #FA4000;
        }
        .sub-title{
            color: #C69C6D;
            font-size: 26px;
            margin-top: 8px;
        }
    }
    .content {
        height: 755px;
        overflow-y: scroll;
    }
    .content-title {
        margin-bottom: 20px;
        font-weight: bold;
        color: #191F34;
        position: relative;
        padding-left: 47px;
        font-size: 26px;
        line-height: 28px;
        padding-right: 30px;
        &:before {
            content: '';
            width: 8px;
            height: 8px;
            background: #C69C6D;
            border-radius: 8px;
            position: absolute;
            left: 25px;
            top: 11px;
        }
    }
    .content-desi {
        margin-bottom: 30px;
        color: #5E6476;
        font-size: 26px;
        padding-left: 48px; 
        padding-right: 30px;
    }
}
</style>